document.addEventListener("DOMContentLoaded", function () {
  const homepageVideoSlider = document.querySelectorAll(
    ".homepage_video-slider.swiper"
  );
  homepageVideoSlider &&
    homepageVideoSlider.forEach((home_video_widget) => {
      new Swiper(home_video_widget, {
        slidesPerView: 4.3,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
        effect: 'coverflow',
        coverflowEffect: {
          rotate: 0,
          stretch: 50,
          depth: 90,
          modifier: 1,
          slideShadows : false,
        },       
        breakpoints: {
          320: {
            slidesPerView: "1.5",
            spaceBetween: 0,
          },
          569: {
            slidesPerView: "2",
            spaceBetween: 0,
          },
          768: {
            slidesPerView: "3",
            spaceBetween: 0,
          },
          992: {
            slidesPerView: "4",
            spaceBetween: 0,
          },
          1199: {
            slidesPerView: "4.3",
            spaceBetween: 0,
          },
          1300: {
            slidesPerView: "4.3",
            spaceBetween: 0,
          },
        },
      });
    });

  const productSlider = document.querySelectorAll(
    ".featured_collection_slider_col.swiper"
  );
  productSlider && productSlider.forEach((product_slider_widget) => {
    new Swiper(product_slider_widget, {
      slidesPerView: 2,
      spaceBetween: 24,
      loop: false,
      navigation: {
        nextEl: ".block__top_collection_next_icon",
        prevEl: ".block__top_collection_prev_icon",
      },
      breakpoints: {
        320: {
          slidesPerView: "1.5",
          autoHeight: true,
        },
        569: {
          slidesPerView: "2",
          spaceBetween: 12,
        },
        768: {
          slidesPerView: "3",
          spaceBetween: 20,
        },
          1200: {
          slidesPerView: "4",
          spaceBetween: 24,
        },
      },
    });
  });

  // instagram slider
  const instaSlider = document.querySelectorAll(
    ".block__instagram_col.swiper"
  );
  instaSlider && instaSlider.forEach((insta_slider_widget) => {
    new Swiper(insta_slider_widget, {
      slidesPerView: 1.5,
      spaceBetween: 12,
      loop: false,
      pagination: {
        el: '.insta-swiper-pagination',
        clickable: true, 
        dynamicBullets: true,
      },      
      breakpoints: {
        1200: {
          slidesPerView: "4",
          spaceBetween: 24,
        },
        576: {
          slidesPerView: "3"
        },        
      },
    });
  }); 
  
  // why choose slider
  const whychooseSlider = document.querySelectorAll(
    ".block__why_choose_col.swiper"
  );
  whychooseSlider && whychooseSlider.forEach((why_choose_widget) => {
    new Swiper(why_choose_widget, {
      slidesPerView: 1.5,
      spaceBetween: 20,
      loop: false,
      pagination: {
        el: '.why-swiper-pagination',
        clickable: true, 
        dynamicBullets: true,
      },
      breakpoints: {
        576: {
          slidesPerView: "2",
          spaceBetween: 24,
        },     
      },
    });
  });   

  // Equal Height Js
  function equl(name) {
    let heading = document.querySelectorAll(name);
    let titleHeight = 0;
    heading.forEach((title) => {
      let matchHeight = title.clientHeight;
      if (matchHeight > titleHeight) {
        titleHeight = title.clientHeight;
      }
    });
    heading.forEach((divHeight) => {
      divHeight.style.minHeight = titleHeight + "px";
    });
  }
  setTimeout(() => {
    equl(".product-card-wrapper");
  }, 500);


  // Newsletter Popup
  const popup = document.getElementById("emailPopup");
  const closeBtn = document.getElementById("closePopup");
  const form = document.querySelector("#newsletterFormss");
  const overlay = document.querySelector(".popup-overlay");

  if (popup) {
    const TEN_MINUTES = 10 * 60 * 1000;
    const INITIAL_DELAY = 2000;

    let popupTimer = null;

    const urlParams = new URLSearchParams(window.location.search);
    const isCustomerPosted =
      urlParams.has("customer_posted") ||
      window.location.hash.includes("contact_form");

    function isSubscribed() {
      return localStorage.getItem("newsletterSubscribed") === "true";
    }

    function getClosedAt() {
      const storedTime = localStorage.getItem("popupClosedAt");

      if (!storedTime) {
        return null;
      }

      const parsedTime = Number(storedTime);

      return Number.isFinite(parsedTime) ? parsedTime : null;
    }

    function showPopup() {
      if (!isSubscribed()) {
        popup.style.display = "flex";
      }
    }

    function schedulePopup() {
      // Cancel any existing popup timer first
      if (popupTimer) {
        clearTimeout(popupTimer);
        popupTimer = null;
      }

      // Never show again once subscribed
      if (isSubscribed()) {
        popup.style.display = "none";
        return;
      }

      const closedAt = getClosedAt();

      // Visitor has never closed the popup
      if (!closedAt) {
        popupTimer = setTimeout(function () {
          showPopup();
        }, INITIAL_DELAY);

        return;
      }

      const timeSinceClosed = Date.now() - closedAt;
      const timeRemaining = TEN_MINUTES - timeSinceClosed;

      // Ten minutes have already passed
      if (timeRemaining <= 0) {
        showPopup();
      } else {
        // Wait only for the remaining portion of the 10 minutes
        popupTimer = setTimeout(function () {
          showPopup();
        }, timeRemaining);
      }
    }

    function closePopup() {
      popup.style.display = "none";

      // Record the exact time the customer closed it
      localStorage.setItem("popupClosedAt", Date.now().toString());

      // Remove Shopify form-success parameters from URL
      const cleanUrl =
        window.location.pathname +
        window.location.search
          .replace(/[?&]customer_posted=true/, "")
          .replace(/^&/, "?") +
        window.location.hash.replace("#contact_form", "");

      window.history.replaceState({}, document.title, cleanUrl);

      // Start a fresh 10-minute countdown
      schedulePopup();
    }

    // Successful newsletter signup
    if (isCustomerPosted) {
      localStorage.setItem("newsletterSubscribed", "true");
      localStorage.setItem("popupClosedAt", Date.now().toString());

      popup.style.display = "flex";

      if (form) {
        form.style.display = "none";
      }

      if (!document.querySelector(".thank-you-message")) {
        const thankYou = document.createElement("p");
        thankYou.className = "thank-you-message";
        thankYou.innerText = "🎉 Thank you for subscribing!";

        const popupBox = document.querySelector(
          ".block__newsletter_popup_right_box"
        );

        if (popupBox) {
          popupBox.appendChild(thankYou);
        }
      }
    } else {
      schedulePopup();
    }

    // X button
    if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
    }

    // Clicking outside popup
    if (overlay) {
      overlay.addEventListener("click", function (e) {
        if (e.target === overlay) {
          closePopup();
        }
      });
    }

    // Newsletter submitted
    if (form) {
      form.addEventListener("submit", function () {
        localStorage.setItem("newsletterSubscribed", "true");
        localStorage.setItem("popupClosedAt", Date.now().toString());
      });
    }
  }

});